import { BarChart } from '@mui/x-charts/BarChart';
import { axisClasses } from '@mui/x-charts/ChartsAxis';
import { chartsGridClasses } from '@mui/x-charts/ChartsGrid';
import { useEffect, useState } from 'react';


function IntakeOverviewChart({ details }) {
    const [smallSize, setSmallSize] = useState(false)

    useEffect(() => {
        // Function to update the window width
        const handleResize = () => {
            if (window.innerWidth < 700) {
                setSmallSize(true)
            } else {
                setSmallSize(false)
            }
        };

        handleResize()

        // Attach the resize event listener
        window.addEventListener('resize', handleResize);

        // Clean up the event listener on unmount
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <div>
            <BarChart
                sx={{
                    [`.${axisClasses.root}`]: {
                        [`.${axisClasses.tick}, .${axisClasses.line}`]: {
                            stroke: 'transparent',
                            strokeWidth: 3,
                        },
                    },
                    [`.${chartsGridClasses.line}`]: {
                        strokeDasharray: '5 3',
                        strokeWidth: 1
                    },
                }}
                grid={{ horizontal: true }}
                dataset={details.map(day => day.data)}
                xAxis={[{
                    scaleType: 'band',
                    tickFontSize: 14,
                    tickLabelStyle: {
                        fontFamily: 'Inter',
                        fontWeight: '600',
                        fill: '#96948F',

                    },
                    tickSize: 20,
                    categoryGapRatio: smallSize ? 0.24 : 0.45,
                    barGapRatio: smallSize ? 0.3 : .4,
                    data: details.map(day => day.label)
                }]}
                yAxis={[{
                    id: 'leftAxisId',
                    tickFontSize: smallSize ? 12 : 14,
                    tickSize: 20,
                    tickLabelStyle: {
                        fontFamily: 'Inter',
                        fontWeight: '600',
                        fill: '#96948F',

                    },
                    disableTicks: smallSize,
                }, {
                    id: 'rightAxisId',
                    tickFontSize: smallSize ? 12 : 14,
                    tickSize: 20,
                    tickLabelStyle: {
                        fontFamily: 'Inter',
                        fontWeight: '600',
                        fill: '#96948F',

                    },
                    disableTicks: smallSize,
                }]}
                slotProps={{ legend: { hidden: true } }}
                series={[
                    { dataKey: 'calories', label: 'Calories', color: '#82BD9C', yAxisId: 'leftAxisId', },
                    { dataKey: 'fat', label: 'Fat', color: '#FE9539', yAxisId: 'rightAxisId', },
                    { dataKey: 'protein', label: 'Protein', color: '#C5C1B9', yAxisId: 'rightAxisId', },
                    { dataKey: 'carb', label: 'Carb', color: '#FF8989', yAxisId: 'rightAxisId', barSize: 30 },
                ]}
                rightAxis="rightAxisId"
                margin={{ left: smallSize ? 55 : 90, right: smallSize ? 50 : 75 }}
                borderRadius={6}
                height={400}
            />
        </div>
    );
}


export default IntakeOverviewChart;